import React from 'react';
import { CpsIndex } from '@cs-cms/types';

export interface ConfigurationLimitStatusProps {
  isLoading: boolean;
  isLoadingPermissions: boolean;
  error: unknown;
  canEdit: boolean;
  selectedIndex: CpsIndex | null;
  currentLimit: number | undefined;
  hasUnsavedChanges: boolean;
  translate: (key: string) => string;
  currentSettingSuffix?: React.ReactNode;
}

function renderStatusMessage(props: ConfigurationLimitStatusProps): React.ReactNode {
  const { isLoading, isLoadingPermissions, error, canEdit, selectedIndex, currentLimit, translate, currentSettingSuffix } =
    props;

  if (isLoading || isLoadingPermissions) {
    return (
      <p className="configurationsCurrentText">
        {translate('custom.settings.adminCenter.configurations.loadingLimit')}
      </p>
    );
  }

  if (error) {
    return (
      <p className="configurationsErrorText">
        {translate('custom.settings.adminCenter.configurations.errorLoadingLimit')}
      </p>
    );
  }

  if (!canEdit) {
    return (
      <p className="configurationsErrorText">
        {translate('custom.settings.adminCenter.configurations.noWritePermission')}
      </p>
    );
  }

  return (
    <p className="configurationsCurrentText">
      {translate('custom.settings.adminCenter.configurations.currentSetting')}{' '}
      {selectedIndex?.displayName || selectedIndex?.name}: {currentLimit} {currentSettingSuffix}
    </p>
  );
}

export const ConfigurationLimitStatus: React.FC<ConfigurationLimitStatusProps> = props => {
  return (
    <div className="configurationsCurrentSetting">
      {renderStatusMessage(props)}
      {props.hasUnsavedChanges && (
        <p className="configurationsUnsavedNotice">
          {props.translate('custom.settings.adminCenter.configurations.unsavedChanges')}
        </p>
      )}
    </div>
  );
};
